import {Button} from '@wandb/weave/components/Button';
import * as DropdownMenu from '@wandb/weave/components/DropdownMenu';
import {Icon} from '@wandb/weave/components/Icon';
import React, {FC} from 'react';

import {useSemanticLegendSettingsContext} from './SemanticLegendSettingsContextProvider';
import {invertColors} from './utils/invertColors';
import {resetColors} from './utils/resetColors';

interface SemanticLegendBucketsActionsProps {
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  isOpen: boolean;
}

export const SemanticLegendBucketsActions: FC<
  SemanticLegendBucketsActionsProps
> = ({setIsOpen, isOpen}) => {
  const {semanticLegendSettings, updateSemanticLegendSettings} =
    useSemanticLegendSettingsContext();

  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <DropdownMenu.Root open={isOpen} onOpenChange={setIsOpen}>
      <DropdownMenu.Trigger>
        <Button
          active={isOpen}
          data-test="buckets-actions-overflow"
          icon="overflow-horizontal"
          variant="ghost"
          aria-label="More actions"
          size={'small'}
        />
      </DropdownMenu.Trigger>
      <DropdownMenu.Portal>
        <DropdownMenu.Content align="center">
          <DropdownMenu.Item
            data-test="invert-colors-button"
            onClick={() => {
              updateSemanticLegendSettings?.(
                invertColors(semanticLegendSettings ?? {})
              );
              handleClose();
            }}>
            <Icon name="swap" /> Invert colors
          </DropdownMenu.Item>
          <DropdownMenu.Item
            data-test="reset-colors-button"
            onClick={() => {
              updateSemanticLegendSettings?.(
                resetColors(semanticLegendSettings ?? {})
              );
              handleClose();
            }}>
            <Icon name="reload-refresh" /> Reset colors
          </DropdownMenu.Item>
        </DropdownMenu.Content>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  );
};
